module.exports = __webpack_public_path__ + "static/img/character-4.d2e6fa6e.png";